var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-popover",
    {
      attrs: { persistent: "", disable: _vm.disabled },
      on: { show: _vm.handleShow, "escape-key": _vm.closePopover },
      model: {
        value: _vm.popover,
        callback: function($$v) {
          _vm.popover = $$v
        },
        expression: "popover"
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }